import { EActionTypes } from './types';
import {
    TSetAppReset,
    TSetCurrentSessionData,
    TSetIsLoggedIn,
} from './actions.types';

export const setCurrentSessionData: TSetCurrentSessionData = (
    currentSessionData,
) => ({
    type: EActionTypes.SET_CURRENT_SESSION_DATA,
    payload: {
        currentSessionData,
    },
});

export const setIsLoggedIn: TSetIsLoggedIn = (isLoggedIn) => ({
    type: EActionTypes.SET_IS_LOGGED_IN,
    payload: {
        isLoggedIn,
    },
});

export const setAppReset: TSetAppReset = () => ({
    type: EActionTypes.APP_RESET,
    payload: null,
});
